import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export default function useNavigationDisabledMessage(isAddingFac = false) {
  const {
    formState: { isDirty },
  } = useFormContext();

  return useMemo(() => {
    if (isAddingFac) return 'Save or delete the new facility before leaving the page';
    if (isDirty) return 'Please save changes before leaving the page';
    return null;
  }, [isAddingFac, isDirty]);
}
